/**
 * The three reports an application can carry — provider-neutral names shared with the backend.
 * Credit always comes from TransUnion; Criminal and Eviction from the application's
 * `backgroundRecordsProvider`. The values are the query-param values the API expects.
 */
export enum ScreeningProductType {
  CREDIT = 'Credit',
  CRIMINAL = 'Criminal',
  EVICTION = 'Eviction',
}
